'use strict';

import angular from 'angular';
import 'ui-select';
import 'angular-bootstrap';
import './appUsersServices';


const appUsersControllers = angular.module('applicationModule.appUsersControllers', [
    'applicationModule.appUsersServices',
    'ui.bootstrap',
    'ui.bootstrap.datepicker',
    'ui.select'
]);

// AppUsers Controllers
appUsersControllers.controller('AppUsersListController', ['$scope', '$rootScope', '$state', '$stateParams', 'NgTableParams', 'growl', 'AppUsers', 'AppsoupAPI', 'Permissions', '$modal', function ($scope, $rootScope, $state, $stateParams, NgTableParams, growl, AppUsers, AppsoupAPI, Permissions, $modal) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.writeAccess = Permissions.hasWriteAccess('users');
    $scope.productsAccess = Permissions.hasAnyAccess('products');
    $scope.dishesAccess = Permissions.hasAnyAccess('dishes');
    $scope.levelsAccess = Permissions.hasAnyAccess('levels');
    $scope.badgesAccess = Permissions.hasAnyAccess('gamifications');
    $scope.user = {};
    $scope.search = {};
    $scope.groups = [];
    $scope.checkedUsers = [];
    $scope.showGroups = false;
    $scope.check = false;
    $scope.tableParams = new NgTableParams(AppsoupAPI.getStatusTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return AppUsers.getList($scope.application_id, params._params)
                .then(function (response) {
                    if (response.success) {
                        var users = response.user;
                        params.total(users.total);
                        params.count(users.per_page);
                        params.page(users.current_page);
                        return users.data;
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.addGroups = function () {
        $scope.user.checkedUsers = $scope.checkedUsers;
        $scope.user.groups = [];
        if ($scope.user.checkedUsers.length !== 0) {
            $scope.showGroups = true;
        }
    };

    $scope.autocomplete = function (text) {
        text = text.replace('#', escape('#'));
        text = text.toLowerCase().trim();
        AppUsers.searchGroups($scope.application_id, text)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    var groups = [];
                    groups = data.groups;
                    angular.forEach($scope.user.groups, function (val) {
                        angular.forEach(data.groups, function (v, k) {
                            if (val == v.id) {
                                groups.splice(k, 1);
                            }
                        });
                    });
                    $scope.groups = groups;
                } else {
                    growl.error('MODULES.APPLICATIONS.MODULES.GROUPS.GROWL.ERROR.' + data.error);
                }
            });
    };

    $scope.mouseLeave = function () {
        $scope.delete = '';
        $scope.edit = '';
        $scope.shopping = '';
        $scope.cart = '';
        $scope.devices = '';
        $scope.dishes = '';
        $scope.obadges = '';
        $scope.favourties = '';
    };

    $scope.mouseOverDelete = function () {
        $scope.delete = 'BUTTONS.DELETE';
    };

    $scope.mouseOverEdit = function () {
        $scope.edit = 'BUTTONS.EDIT';
    };

    $scope.mouseOverShoppingList = function () {
        $scope.shopping = 'MODULES.APPUSERS.BTN.SHOPPING_LIST';
    };

    $scope.mouseOverCart = function () {
        $scope.cart = 'MODULES.APPUSERS.BTN.CART';
    };

    $scope.mouseOverDevices = function () {
        $scope.devices = 'MODULES.APPUSERS.BTN.DEVICES';
    };

    $scope.mouseOverDishes = function () {
        $scope.dishes = 'MENU.DISHES';
    };

    $scope.mouseOverBadges = function () {
        $scope.obadges = 'MODULES.APPUSERS.BTN.BADGES';
    };

    $scope.mouseOverFavourties = function () {
        $scope.favourties = 'MODULES.APPUSERS.BTN.FAVOURTIES';
    };

    $scope.cancel = function () {
        $scope.showGroups = false;
    };

    $scope.save = function () {
        $scope.user.checkedUsers = $scope.checkedUsers;
        if (angular.isDefined($scope.user.groups) && $scope.user.groups.length > 0) {
            AppUsers.saveGroups($scope.user)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.APPLICATIONS.MODULES.USERS.GROWL.SUCCESS.ADD_GROUPS');
                    } else {
                        growl.error('MODULES.APPLICATIONS.MODULES.USERS.GROWL.ERROR.' + ($scope.user.checkedUsers.push() ? 'EXISTS_USER' : 'ADD_GROUPS'));
                    }
                });
        } else {
            growl.error('MODULES.APPLICATIONS.MODULES.USERS.GROWL.ERROR.EMPTY_GROUPS');
        }
        $scope.showGroups = false;
        $scope.checkedUsers = [];
    };

    $scope.removeUser = function (id, index) {
        AppUsers.remove(id, $scope.application_id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.USERS.SUCCESS.DELETE_USER');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.USERS.ERROR.NO_RESOURCE');
                }
            });
    };

    $scope.importQuestionnaire = function () {
        $modal.open({
            templateUrl: 'views/application/users/components/modal/questionnaire.tpl.html',
            controller: 'AppUserImportModalController',
            resolve: {
                modalData: function () {
                    return {
                        app_id: $scope.application_id
                    };
                }
            }
        });
    };

    $scope.selectUser = function (id) {
        $scope.checkedUsers = angular.selectElement($scope.checkedUsers, id);
    };

    $scope.selectAllUsers = function (item) {
        $scope.checkedUsers = angular.selectAllElements($scope.checkedUsers, item);
    };
    $scope.checkSelectedUsers = function (item) {
        return angular.checkSelectedElements($scope.checkedUsers, item);
    };

    $scope.searchUser = function (search) {
        $scope.isFind = true;
        var find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };
    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);

appUsersControllers.controller('AppUserDetailController', ['$scope', '$rootScope', '$stateParams', '$state', 'AppUsers', function ($scope, $rootScope, $stateParams, $state, AppUsers) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.userId = $stateParams.userId;
    $scope.type = $stateParams.type;
    $scope.pageTitle = '';
    AppUsers.getDetail($scope.application_id, $scope.userId, $scope.type)
        .then(function (response) {
            if (response) {
                $scope.detail = response.detail;
                $scope.detail.products = angular.fromJson(response.products);
            } else {
                $scope.detail = {};
            }
        });

    $scope.back = function () {
        $state.go('appsoup.application.users');
    };

    if ($scope.type == 1) {
        $scope.pageTitle = 'MODULES.APPUSERS.BTN.SHOPPING_LIST';
    } else if ($scope.type == 2) {
        $scope.pageTitle = 'MODULES.APPUSERS.BTN.CART';
    } else if ($scope.type == 3) {
        $scope.pageTitle = 'MODULES.APPUSERS.BTN.FAVOURTIES';
    }

    $state.current.ncyBreadcrumb.label = $scope.pageTitle;
}]);

appUsersControllers.controller('AppUserDeviceController', ['$scope', '$rootScope', '$stateParams', '$state', 'AppUsers', function ($scope, $rootScope, $stateParams, $state, AppUsers) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.userId = $stateParams.userId;
    AppUsers.getDevice($scope.userId)
        .then(function (response) {
            $scope.devices = response ? response : {};
        });
    $scope.back = function () {
        $state.go('appsoup.application.users');
    };
}]);

appUsersControllers.controller('AppUserController', ['$scope', '$rootScope', '$stateParams', '$state', 'AppUsers', 'growl', 'App', function ($scope, $rootScope, $stateParams, $state, AppUsers, growl, App) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.userId = $stateParams.userId;
    $scope.user = {
        app_id: $scope.application_id,
        json_data: {},
        status: true
    };
    $scope.editMode = false;
    $scope.schema = [];
    $scope.emptyTable = [];
    $scope.errors = {};
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.groups = [];
    $scope.isRequired = true;

    App.getMenu().then(function (response) {
        if (angular.isDefined(response)) {
            $scope.applications = response.applications.data;
        }
    });

    AppUsers.getSchema($scope.application_id).then(function (response) {
        if (response) {
            $scope.schema = response.schema.structure;
            $scope.upload = {};
            $scope.fileUploaded = {};
            $scope.groups = response.groups;
            if (angular.isDefined($scope.userId)) {
                $scope.editMode = true;
                AppUsers.get($scope.userId, $scope.application_id).then(function (result) {
                    let data = result.data;

                    if (data) {
                        $scope.user = data.user;
                        var groupIds = data.groups;
                        var groups = [];
                        if (angular.isDefined(groupIds)) {
                            AppUsers.searchGroups($scope.application_id, '')
                                .then(function (result) {
                                    let data = result.data;

                                    $scope.groups = data.groups;
                                    angular.forEach($scope.groups, function (val) {
                                        angular.forEach(groupIds, function (v) {
                                            if (v == val.id) {
                                                groups.push(v);
                                            }
                                        });
                                    });
                                });

                            $scope.user.groups = groups;
                        }

                        angular.forEach($scope.schema, function (val) {
                            if (val.type == 'image') {
                                if (angular.isDefined($scope.user.json_data) && (angular.isDefined($scope.user.json_data[val.key]))) {
                                    $scope.fileUploaded[val.key] = true;
                                } else {
                                    $scope.upload[val.key] = undefined;
                                    $scope.fileUploaded[val.key] = false;
                                }
                            }
                            if (val.type == 'float') {
                                if (angular.isDefined($scope.user.json_data) && (angular.isDefined($scope.user.json_data[val.key]))) {
                                    $scope.user.json_data[val.key] = $scope.user.json_data[val.key].toString().replace(".", ",");
                                }
                            }
                        });
                    }
                }).catch(function () {
                    $state.go('appsoup.application.users', growl.error('ERROR.EMPTY_DATA'));
                }).finally(function () {
                    $rootScope.doingResolve = false;
                });
            }
        }
    });
    $scope.autocomplete = function (text) {
        text = encodeURIComponent(text);
        text = text.toLowerCase().trim();
        AppUsers.searchGroups($scope.application_id, text).then(function (result) {
            let data = result.data;

            if (data.success) {
                var groups = [];
                groups = data.groups;
                angular.forEach($scope.user.groups, function (val) {
                    angular.forEach(data.groups, function (v, k) {
                        if (val == v.id) {
                            groups.splice(k, 1);
                        }
                    });
                });
                $scope.groups = groups;
            } else {
                growl.error('MODULES.APPLICATIONS.MODULES.GROUPS.GROWL.ERROR.' + data.error);
            }
        });
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.users');
    };

    $scope.save = function () {
        $scope.$broadcast('show-errors-check-validity');

        if ($scope.dataForm.$valid) {
            var user = angular.copy($scope.user);
            AppUsers.save(user, $scope.upload, $scope.editMode).then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.USERS.SUCCESS.EDIT_USER');
                    $state.go('appsoup.application.users');
                } else {
                    $scope.formErrors = data.errors.user;
                    $scope.errors = data.errors.json_data;
                }
            });
        }
    };

    $scope.notSelectiveType = function (type) {
        return type !== 'tag' && type !== 'select' && type !== 'image' && type !== 'checkbox' && type !== 'float' && type !== 'table';
    };

    $scope.checkValid = function (name) {
        return angular.isDefinedNotNull($scope.errors[name]);
    };

    $scope.changeComma = function (data) {
        return data.replace(',', '.');
    };

    $scope.removeFile = function (key) {
        delete $scope.upload[key];
        if (angular.isDefined($scope.user.json_data) && angular.isDefined($scope.user.json_data[key])) {
            delete $scope.user.json_data[key];
        }
        $scope.fileUploaded[key] = false;
    };

    $scope.uploadSuccess = function (file, key) {
        $scope.upload[key] = file;
        $scope.fileUploaded[key] = true;
        $scope.$apply();
    };

    $scope.inputErrors = {
        'email': [
            {error: 'required', msg: 'USER.EMAIL_REQUIRED'},
            {
                error: 'pattern',
                msg: 'USER.INVALID_FORM_EMAIL'
            }
        ],
        'password': [
            {error: 'required', msg: 'ERROR.REQUIRE.PASS'},
            {
                error: 'minlength',
                msg: 'ERROR.MIN_LENGTH.PASS',
                vars: '{ charsQty: 6 }'
            }
        ],
        'password_verify': [
            {error: 'required', msg: 'ERROR.REQUIRE.PASS'},
            {error: 'minlength', msg: 'ERROR.MIN_LENGTH.PASS', vars: '{ charsQty: 6 }'},
            {error: 'match', msg: 'ERROR.DIFFERENT_PASS'}
        ]
    };

    $scope.$watchGroup(['user.password_verify', 'user.password'], function () {
        var isValid = !($scope.user.password !== $scope.user.password_verify && !$scope.dataForm.password_verify.$pristine);
        $scope.dataForm.password_verify.$setValidity('match', isValid);
    });
}]);

appUsersControllers.controller('AppUserDishOrdersController', ['$scope', '$rootScope', '$stateParams', '$filter', '$state', function ($scope, $rootScope, $stateParams, $filter, $state) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.userId = $stateParams.userId;
    $scope.date = Date.now();
    $state.go('appsoup.application.userDishOrders.date', {
        'application_id': $scope.application_id,
        'userId': $scope.userId,
        'date': $filter('date')($scope.date, 'yyyy-MM-dd')
    });

    $scope.checkDate = function () {
        $state.go('appsoup.application.userDishOrders.date', {
            'application_id': $scope.application_id,
            'userId': $scope.userId,
            'date': $filter('date')($scope.date, 'yyyy-MM-dd')
        });
    };

}]);
appUsersControllers.controller('AppUserBadgesController', ['$scope', '$rootScope', '$stateParams', 'AppUsers', function ($scope, $rootScope, $stateParams, AppUsers) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.userId = $stateParams.userId;

    AppUsers.badges($scope.application_id, $scope.userId)
        .then(function (response) {
            if (response.success) {
                $scope.data = response.data;
                $scope.actions = response.actions;
            }
        })
        .finally(function () {
            $scope.isLoading = false;
        });
}]);

appUsersControllers.controller('AppUserDishOrdersDateController', ['$scope', '$rootScope', '$stateParams', '$state', 'AppUsers', function ($scope, $rootScope, $stateParams, $state, AppUsers) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.userId = $stateParams.userId;
    $scope.date = $stateParams.date;
    $scope.isLoading = true;

    AppUsers.dishOrders($scope.application_id, $scope.userId, $scope.date)
        .then(function (response) {
            if (response.success) {
                $scope.data = response.data;
                $scope.total = response.total;
            }
        })
        .finally(function () {
            $scope.isLoading = false;
        });


    $scope.cancel = function () {
        $state.go('appsoup.application.users');
    };

}]);

appUsersControllers.controller('AppUsersActivityController', ['$scope', '$rootScope', '$state', '$stateParams', 'NgTableParams', 'growl', 'AppUsers', 'LevelBeaconAPI', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, NgTableParams, growl, AppUsers, LevelBeaconAPI, AppsoupAPI, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.writeAccess = Permissions.hasWriteAccess('levels');

    $scope.search = {};
    $scope.beacons = [];

    $scope.tableParams = new NgTableParams(AppsoupAPI.getUserTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return AppUsers.getUsersActivities($scope.application_id, params._params)
                .then(function (response) {
                    if (response.success) {
                        var users = response.data;
                        params.total(users.total);
                        params.count(users.per_page);
                        params.page(users.current_page);
                        return users.data;
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                    $scope.isFind = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.searchUsers = function (search) {
        $scope.isFind = true;
        var find = angular.copy(search);
        $scope.find = angular.copy(search);
        $scope.find = '';
        angular.forEach(search.beacons, function (val) {
            $scope.find += '&beacons[]=' + val;
        });
        angular.extend($scope.tableParams._params, find);
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.find = '';
        delete $scope.search.beacons;
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.beacons)) {
            $scope.tableParams._params.beacons = undefined;
        }
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        if (angular.isDefined($scope.search.beacons) && Object.keys($scope.search.beacons).length > 0) {
            $scope.check = true;
        } else {
            $scope.check = false;
        }
    }, true);

    $scope.autocomplete = function (text) {
        text = text.toLowerCase().trim();
        text = encodeURIComponent(text);
        LevelBeaconAPI.autocomplete($scope.application_id, text)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    var beacons = [];
                    beacons = data.data;
                    if (angular.isDefined($scope.search.beacons)) {
                        angular.forEach($scope.search.beacons, function (val) {
                            angular.forEach(data.data, function (v, k) {
                                if (val == v.id) {
                                    beacons.splice(k, 1);
                                }
                            });
                        });
                    }
                    $scope.beacons = beacons;
                }
            });
    };

    // DatePickers
    $scope.report = {
        start_date: new Date(),
        end_date: new Date()
    };

    $scope.popup_start = {
        opened: false
    };

    $scope.popup_end = {
        opened: false
    };

    $scope.format = 'dd-MM-yyyy';

    $scope.dateOptions = {
        dateDisabled: false,
        formatYear: 'yy',
        startingDay: 1
    };

    $scope.startDate = function () {
        $scope.popup_start.opened = true;
    };

    $scope.endDate = function () {
        $scope.popup_end.opened = true;
    };
}]);

appUsersControllers.controller('AppUserImportModalController', ['$scope', '$stateParams', '$rootScope', '$modalInstance', 'modalData', 'AppUsers', 'growl', '$translate', function ($scope, $stateParams, $rootScope, $modalInstance, modalData, AppUsers, growl, $translate) {
    var appId = $stateParams.application_id;

    $scope.upload = undefined;
    $scope.isLoading = false;

    $scope.uploadSuccess = function (file) {
        $scope.isLoading = true;
        $scope.upload = file;

        AppUsers.importData(appId, $scope.upload).then(function (result) {
            let data = result.data;

            if (data.success) {
                growl.success('MODULES.APPLICATIONS.MODULES.USERS.IMPORT.SUCCESS');
                $modalInstance.close();
            } else {
                var transError = 'ERROR.' + data.error;
                $translate(transError).then(function () {
                }, function () {
                    transError = 'ERROR.UNRECOGNISED';
                }).finally(function () {
                    growl.error(transError);
                });
            }
        }).finally(function () {
            $scope.isLoading = false;
        });
    };

}]);

appUsersControllers.controller('ImportActionsDataController', ['$scope', '$rootScope', '$stateParams', '$state', 'growl', 'AppUsers', 'WebpagesAPI', '$translate', function ($scope, $rootScope, $stateParams, $state, growl, AppUsers, WebpagesAPI, $translate) {
    var content = $('#content').offset();
    $('html, body').animate({scrollTop: content.top}, "slow");
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.page_id = $stateParams.page_id;
    $scope.module_id = $stateParams.module_id;
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;
    $scope.filesKeys = [];
    $scope.labels = [];
    $scope.data = {};
    $scope.incrementally = {};
    $scope.file_name = {};
    $scope.columns_count = [];
    $scope.wrongFiles = [];

    $scope.isDatepickerOpen = {};

    $scope.closeCalendar = function (key) {
        $scope.isDatepickerOpen[key] = false;
    };

    WebpagesAPI.getActionConfig($scope.page_id, $scope.module_id)
        .then(function (result) {
            let data = result.data;

            if (data.success) {
                var filesCount = parseInt(data.data.files_count);
                $scope.config = data.data;
                $scope.upload = {};
                $scope.fileUploaded = {};
                $scope.errorRequired = {};
                for (var i = 0; i < filesCount; i++) {
                    if (angular.isDefined(data.data.file_name)) {
                        $scope.file_name[i] = data.data.file_name[i];
                    }
                    $scope.filesKeys.push(i);
                    $scope.upload[i] = undefined;
                    $scope.fileUploaded[i] = false;
                    $scope.errorRequired[i] = false;
                }
                $scope.elements = data.data.elements;
                $scope.labels = data.data.labels;
                $scope.columns_count = data.data.columns_count;
            }
        });

    $scope.removeFile = function (key) {
        $scope.upload[key] = undefined;
        $scope.fileUploaded[key] = false;
        $scope.errorRequired[key] = true;
        $scope.wrongFiles = [];
    };

    $scope.uploadSuccess = function (file, key) {
        $scope.upload[key] = file;
        $scope.fileUploaded[key] = true;
        $scope.errorRequired[key] = false;
        $scope.$apply();
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.webpages', {application_id: $scope.application_id, page_id: $scope.page_id});
    };

    $scope.saveFile = function () {
        $scope.$broadcast('show-errors-check-validity');
        if ($scope.dataImportForm.$valid) {
            $scope.isLoading = true;

            AppUsers.import($scope.application_id, $scope.page_id, $scope.module_id, $scope.data, $scope.upload, $scope.incrementally.incrementally)
                .then(function (result) {
                    let data = result.data;

                    if (data.success) {
                        growl.success('MODULES.ACTIONS.SUCCESS.IMPORT');
                        $state.go('appsoup.application.webpages', {
                            application_id: $scope.application_id,
                            page_id: $scope.page_id
                        });
                    } else if (data.error === 'Invalid columns number!') {
                        growl.error(data.error);
                    } else if (data.error === 'Invalid encoding!') {
                        if (angular.isDefined(data.fileNames)) {
                            $scope.wrongFiles = data.fileNames;
                            let text = '';
                            text = text + $translate.instant('MODULES.ACTIONS.ERROR.FILE_ENCODING') + '   ';
                            angular.forEach(data.fileNames, function (value, key) {
                                text = text + value;
                                if (data.fileNames.length - 1 === key) {
                                    text = text + '.';
                                } else {
                                    text = text + ', ';
                                }
                            });
                            growl.error(text, {translateMessage: false});
                        }
                    } else {
                        growl.error('MODULES.ACTIONS.ERROR.' + (data.error === 'Invalid number of files!' ? 'TOO_FEW_FILES' : 'IMPORT'));
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    };
}]);

appUsersControllers.controller('DeleteActionsDataController', ['$scope', '$rootScope', '$stateParams', '$state', 'growl', 'AppUsers', 'WebpagesAPI', function ($scope, $rootScope, $stateParams, $state, growl, AppUsers, WebpagesAPI) {
    var content = $('#content').offset();
    $('html, body').animate({scrollTop: content.top}, "slow");
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.application_id = $stateParams.application_id;
    $scope.page_id = $stateParams.page_id;
    $scope.module_id = $stateParams.module_id;
    $scope.upload = undefined;
    $scope.fileUploaded = false;
    $scope.errorRequired = false;

    WebpagesAPI.getActionInfoToDelete($scope.page_id, $scope.module_id)
        .then(function (result) {
            let data = result.data;

            if (data.success) {
                $scope.config = data.data;
            }
        });

    $scope.removeFile = function () {
        $scope.upload = undefined;
        $scope.fileUploaded = false;
        $scope.errorRequired = true;
    };

    $scope.uploadSuccess = function (file) {
        $scope.upload = file;
        $scope.fileUploaded = true;
        $scope.errorRequired = false;
        $scope.$apply();
    };

    $scope.cancel = function () {
        $state.go('appsoup.application.webpages', {application_id: $scope.application_id, page_id: $scope.page_id});
    };

    $scope.saveFile = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;

        AppUsers.deleteActionsData($scope.application_id, $scope.page_id, $scope.module_id, $scope.upload)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.ACTIONS.SUCCESS.DELETE');
                    // $state.go('appsoup.application.webpages', {
                    //     application_id: $scope.application_id,
                    //     page_id: $scope.page_id
                    // });
                } else {
                    growl.error(data.error);
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };
}]);

export default appUsersControllers;